import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getWeakness } from '../../../apis/report';
import CustomTable from '../../../components/UI/CustomTable';
import { CellType } from '../../../types/Common';
import CustomButton from '../../../components/UI/CustomButton';
import useStyles from './useStyles';
import Loading from '../../../components/Loading';
import { typeMappingHandler } from '../../../constants/keysMapping';

const tableHead = [
  {
    key: 'row',
    label: 'ردیف',
    type: CellType.ROW,
  },
  {
    key: 'name',
    label: 'نام',
    type: CellType.STRING,
  },
  {
    key: 'lastName',
    label: 'نام خانوادگی',
    type: CellType.STRING,
  },
  {
    key: 'testId',
    label: 'مشاهده نتیجه آزمون',
    type: CellType.TEST,
  },
];

const Weakness = () => {
  const classes = useStyles();
  const [skillList, setSkillList] = useState([]);
  const [users, setUsers] = useState([]);
  const [skill, setSkill] = useState('');
  const [loading, setLoading] = useState(false);

  const getWeaknessData = () => {
    setLoading(true);
    getWeakness(skill)
      .then((res: any) => setUsers(res))
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  };

  const getSkillList = () => {
    setLoading(true);
    getWeakness()
      .then((res: any) => setSkillList(res))
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getSkillList();
  }, []);

  if (loading) return <Loading fullHeight={false} />;

  return (
    <>
      <Box className={classes.topContainer}>
        <Box className={classes.skillContainer}>
          {skillList.map((value: string) => (
            <Box
              className={classes.boxContainer}
              onClick={() => setSkill(value)}
              sx={{
                backgroundColor: value === skill ? '#FFF1E6' : 'translate',
                borderColor: value === skill ? '#FF6B00' : '#DCDFE1',
              }}
            >
              <Typography color='text.main' fontSize='small' fontWeight='bold'>
                {typeMappingHandler(value).message}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box className={classes.actionContainer}>
          <CustomButton loading={loading} disabled={loading || !skill} onClick={getWeaknessData}>
            <Typography px={2}>اعمال فیلتر</Typography>
          </CustomButton>
        </Box>
      </Box>

      <Box mt={2}>
        <CustomTable rows={users} tableHead={tableHead} size='small' />
      </Box>
    </>
  );
};
export default Weakness;
